import React from 'react'
import { useState, useEffect, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Svg,
  Player,
  NavTabs,
  Container,
  NoContent,
  ModalCarousel,
  TitleWithPoster,
  MoviesDatesFilter
} from "app/components";
import { PosterMovieDetails } from '../styles';

const propTypes = {
  movieDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
};

const VideoPoster = ({
  movieDetails,
  isVisible,
  WatchListBtn,
  EntityGallery,
  isLoggedIn,
  location
}) => {

  const {
    titleOriginalCalculated,
    descriptionCalculated,
    descriptionShortCalculated,
    trailers,
    rating,
    ratingGetmesh,
    ratingGetmeshEn,
    runTime
  } = movieDetails;

  const [isModal, setModal] = useState(false);
  const [trailerToShow, selectTrailer] = useState(trailers && trailers.length ? 0 : null);

  const openModal = useCallback(() => setModal(true), []);
  const closeModal = useCallback(() => setModal(false), []);


  useEffect(() => {
    if (!trailerToShow && trailers && trailers.length) {
      selectTrailer(0);
    }
  }, [trailers]);

  useEffect(() => {
    let touchstartX = 0;
    let touchendX = 0;

    const posterElement = document.getElementById("mobile_video_poster_container")

    function checkDirection() {
      if (touchendX < touchstartX) {
        if (trailerToShow < trailers.length - 1) {
          selectTrailer(trailerToShow + 1)
        }
      }
      if (touchendX > touchstartX) {
        if (trailerToShow > 0) {
          selectTrailer(trailerToShow - 1)
        }
      }
    }
    const touchStart = e => {
      touchstartX = e.changedTouches[0].screenX;
    }
    const touchEnd = e => {
      touchendX = e.changedTouches[0].screenX;
      checkDirection()
    }
    if (posterElement) {
      posterElement.addEventListener('touchstart', touchStart)
      posterElement.addEventListener('touchend', touchEnd)
    }
    return () => {
      if (posterElement) {
        posterElement.removeEventListener('touchstart', touchStart)
        posterElement.removeEventListener('touchend', touchEnd)
      }
    }
  }, [trailerToShow])

  return (
    <PosterMovieDetails>
      {trailerToShow !== null ? (
        <Fragment>
          <div className="b-trailer" id="mobile_video_poster_container">
            <div className="b-trailer__poster">
              <img
                className="b-trailer__poster-img"
                src={trailers[trailerToShow].keyframeUrl}
                alt=""
              />
              <button
                type="button"
                className="b-trailer__btn-play"
                onClick={openModal}
              >
                <Svg id="play" />
              </button>
            </div>
            {movieDetails.id ? (
              <Fragment>
                <TitleWithPoster
                  entityDetails={movieDetails}
                  location={location}
                >
                  {isLoggedIn ? (
                    <WatchListBtn
                      id={movieDetails.id}
                      isInWatchList={movieDetails.isInWatchlist}
                      isDetails
                    />
                  ) : null}
                </TitleWithPoster>
              </Fragment>
            ) : null}
          </div>

          {trailers.length > 1 ? (
            <div className="b-trailer__switcher">
              {trailers.map((item, i) => (
                <button
                  key={item.trailerKey}
                  type="button"
                  onClick={() => {
                    selectTrailer(i);
                  }}
                  className={`b-trailer__switcher-btn ${trailerToShow === i ? ' _active' : ''}`}
                />
              ))}
            </div>
          ) : null}
        </Fragment>
      ) : null}
      {/* Model for Video Trailer */}
      <ModalCarousel isOpen={isModal} close={closeModal} >
        <Player
          id={isModal ? trailers[trailerToShow].trailerKey : ''}
          keyFrameUrl={isModal ? trailers[trailerToShow].keyframeUrl : ''}
        />
      </ModalCarousel>
    </PosterMovieDetails>
  )
}

VideoPoster.propTypes = propTypes;

export default VideoPoster;